var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module"},[_c('kpi-with-chart',{attrs:{"data":_vm.kpiData,"mainKpiData":_vm.mainKpiData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }